module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./RuleView.js"));
	}, "RuleView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RuleView!./src/pages/Learn/My/Rule/RuleView.js
// module id = 2212
// module chunks = 367